export const ENTERPRISE_LP_URL = 'https://lp.wabunka-lux.jp/largegroup';
